import { detector } from './detector';
import { getURL, query } from '../query';
import { trackLaunchAppEvent, upLaunchAppEvent } from '../webx';
import { getNineChapterWebxParams } from '../statistic';
import { bridge } from '../platform/bridge';
import showPassphraseView from './ui/passphrase-ui';
const isIos = detector.os.name === 'ios';
const isAndroid = detector.os.name === 'android';
const isIOSWithLocationCallSupport = isIos && detector.browser.name == 'safari' && detector.os.version >= 9;
const isChromeWithLocationCallSupport = detector.browser.name == 'chrome' && detector.browser.version > 55;
const isSamsungWithLocationCallSupport = detector.browser.name == 'samsung';
const isAndroidWithLocationCallSupport = isAndroid && (isChromeWithLocationCallSupport || isSamsungWithLocationCallSupport);
const locationCall = (url) => {
    (top.location || location).href = url;
};
const iframeCall = (url) => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);
    setTimeout(function () {
        document.body.removeChild(iframe);
    }, 200);
};
let launchAppEnv = 'online';
export const setLaunchAppEnv = (env) => {
    env && (launchAppEnv = env);
};
export const getLaunchAppEnv = () => {
    return launchAppEnv;
};
// 获取拉端方法
export const getOpenMethod = (openType) => {
    return openChannel[openType];
};
// 强制阻断拉端
export const forcePull = (linkObj, browser) => {
    const { linkType, link, extraParam } = linkObj;
    // 埋点：上报拉端事件埋点
    trackLaunchAppAction(getDeepLink(linkObj));
    const openMethod = getOpenMethod(linkTypeToOpenMethodMap[linkType]);
    if (linkType === 7) {
        // 拉起小程序
        openMethod(extraParam, browser);
    }
    else {
        openMethod && openMethod(link, true);
    }
};
// 拉端类型映射表，落地页曝光或者按你点击
export const pullEventTypeMap = {
    'LANDPAGE_EXPOSE': '1',
    'BTN_CLICK': '2',
};
// webx服务下发拉端类型映射表
export const pullTypeMap = {
    // 强制拉起
    'FORCE_PULL': 1,
    // 引导拉起
    'GUIDE_PULL': 2,
    // 无动作
    'NO_ACTION': 3,
    // 拉端口令
    'PASSPHRASE': 4,
};
// webx服务下发拉端链接类型对应拉端方法映射表
export const linkTypeToOpenMethodMap = {
    1: 'link',
    2: 'scheme',
    3: 'wx_scheme',
    4: 'download',
    5: 'guide',
    6: 'passphrase',
    7: 'bridge'
};
// 不同的拉端方法
const openChannel = {
    // universal link / app link
    link: function (url) {
        locationCall(url);
    },
    scheme: function (url) {
        if (isIOSWithLocationCallSupport || isAndroidWithLocationCallSupport) {
            locationCall(url);
        }
        else {
            iframeCall(url);
        }
    },
    // 打开微信scheme
    wx_scheme: function (url) {
        if (isIOSWithLocationCallSupport || isAndroidWithLocationCallSupport) {
            locationCall(url);
        }
        else {
            iframeCall(url);
        }
    },
    // 下载
    download: function (url) {
        locationCall(url);
    },
    // 拉端口令
    passphrase: showPassphraseView,
    // 调用快手和乘客端的bridge拉起微信小程序
    bridge: (data, browser) => {
        const { originalID, path, type } = data;
        if (!browser || browser === 'kuaishou') {
            window['callback_openWechatMiniProgram'] = (e) => {
                console.log('callback_openWechatMiniProgram====>', e);
            };
            const KwaiAdThird = window['KwaiAdThird'];
            if (KwaiAdThird) {
                KwaiAdThird.callAdBridge(JSON.stringify({
                    'action': 'openWechatMiniProgram',
                    'data': JSON.stringify({ originalID, path, type }),
                    'callback': 'callback_openWechatMiniProgram'
                })).then(res => {
                    console.log('调用成功！', res);
                }).catch(e => {
                    console.error('调用失败', e);
                });
            }
        }
        else if (browser === 'didi') {
            bridge.launchWeChatMiniApp({
                appId: originalID,
                path,
                programType: type,
            }, res => {
                if (res.errno === 0) {
                    console.log('调用成功！', res.errmsg);
                }
                else {
                    console.error('调用失败', res.errmsg);
                }
            });
        }
    }
};
// 进端事件上报埋点
export const trackLaunchAppAction = (deeplink) => {
    const params = {
        args: {
            url: getURL(),
            deeplink,
        },
        ...getLaunchAppCommonParams()
    };
    trackLaunchAppEvent(params, launchAppEnv);
};
// 拉端请求通用参数
const launchAppCommonParamsKey = [
    'entrance_channel',
    'prod_key',
    'dchn',
    'xpsid',
    'xpsid_from',
    'xpsid_root',
    'xbiz',
    'uid',
    'xenv',
    'xspm_from',
];
// 获取拉端通用参数
export const getLaunchAppCommonParams = () => {
    const urlParams = query();
    const nineChapterWebxParams = getNineChapterWebxParams();
    const params = {};
    launchAppCommonParamsKey.forEach(key => {
        params[key] = urlParams[key] || nineChapterWebxParams[key] || '';
    });
    return params;
};
// 拉端埋点
export const trackEvent = (eventId, data = {}) => {
    const launchAppCommonParams = getLaunchAppCommonParams();
    const { dchn, xpsid } = launchAppCommonParams;
    const params = {
        args: {
            event_id: eventId || '',
            page_url: window.location.href,
            dchn,
            ts: Date.now(),
            attrs: {
                ...data,
                xpsid,
                page_url: window.location.href,
            }
        },
        ...launchAppCommonParams,
    };
    try {
        upLaunchAppEvent(params, launchAppEnv);
    }
    catch (error) {
        console.log('event up failed: ', error);
    }
};
export function getDeepLink(linkObj) {
    let link = linkObj.link;
    const extraParam = linkObj.extraParam || {};
    if (extraParam.originalID && extraParam.path) {
        link = extraParam.path; // 此时link为空，使用 extraParam.path
    }
    return link;
}
